module.exports = __webpack_public_path__ + "static/media/profile_photo.d1676f84.jpeg";